import React from 'react'
import a from "../Images/logo.png"
import { motion} from 'framer-motion'

function Footer() {
  return (
    <motion.div
      variants={{
        hidden:{opacity:0,y:600},
        visible:{opacity:1,y:0}
      }}
      initial="hidden"
      animate="visible"
      transition={{duration:2,delay:0}}
    >
        <div className='d-flex justify-content-center mt-5'>
            <img src={a} style={{width:"120px"}} alt="footer logo"></img>
        </div>
        <div className='d-flex justify-content-center mt-4'>
            <i class="fa-brands fa-instagram fa-lg me-3" style={{color: "#000000;"}}></i>
            <i class="fa-brands fa-whatsapp fa-lg" style={{color: "#000000;"}}></i>
            <i class="fa-brands fa-facebook fa-lg me-3 ms-3" style={{color: "#000000;"}}></i>
        </div>
        <div className='d-flex justify-content-center mt-3'>
            <p><strong>b# Music &copy; 2023</strong></p>
        </div>
    </motion.div>
  )
}

export default Footer   